import React, { useState, useImperativeHandle, forwardRef } from 'react';
import FormSelectMaterial from '../../../nuup/componentes/Forms/FormSelectMaterial.jsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { es } from 'date-fns/locale';
import { isWithinInterval } from 'date-fns';

// eslint-disable-next-line react/display-name
const AvancesFilters = forwardRef((props, ref) => {
  const today = new Date();
  const [inspector, setInspector] = useState(0);
  const [ubicacion, setUbicacion] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  //To call outside
  useImperativeHandle(ref, () => ({
    setDefaultFilters: setDefaultFiltersHandler,
  }));

  const setDefaultFiltersHandler = () => {
    setInspector(0);
    setUbicacion(0);
    setStartDate(null);
    setEndDate(null);
  };

  const handleFilters = (key, val, setFilter) => {
    setFilter(val);
    let data = props.dataAvancesTotal;
    // update data filtered
    if (val === 0 || val === '') {
      props.setDataAvances(props.dataAvancesTotal);
      setDefaultFiltersHandler(); // without subfilters
    } else {
      const filters = {
        id_localidad: ubicacion,
        id_inspector: inspector,
        inspeccion_fecha: [key == 'startDate' ? val : startDate, key == 'endDate' ? val : endDate],
      };
      Object.prototype.hasOwnProperty.call(filters, key) && (filters[key] = val);
      for (const [key, value] of Object.entries(filters)) {
        if (!(value === 0 || value === '' || value === null || (Array.isArray(value) && value[0] === null))) {
          if (key == 'inspeccion_fecha') {
            // filter by fecha
            const fechaInicio = new Date(value[0]);
            const fechaFin = value[1] ? new Date(value[1]) : new Date(today);
            data = data.filter(d => isWithinInterval(new Date(d[key]), { start: fechaInicio, end: fechaFin }));
          } else {
            data = data.filter(d => d[key] == value);
          }
        }
      }
      props.setDataAvances(data);
    }
  };

  const getCatByData = list => {
    return props.dataAvances
      .map(d => {
        return {
          value: d['id_' + list],
          label: d['nombre_' + list],
        };
      })
      .filter((item, index, self) => index === self.findIndex(t => t.value === item.value))
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
  };

  const DateCustomInput = forwardRef(({ value, onClick, className }, ref) => (
    <div onClick={onClick} ref={ref} style={{ cursor: 'pointer', alignItems: 'center' }} className="d-flex">
      <input value={value} className={className} readOnly />
      <CalendarTodayIcon style={{ color: '#464741', position: 'absolute', right: '4px', fontSize: 'medium' }} />
    </div>
  ));
  
  return (
    <div className="row mt-3 mb-4 pr-2">
      <div className="col-6 mb-3">
        <label>Desde</label>
        <DatePicker
          selected={startDate}
          onChange={val => handleFilters('startDate', val, setStartDate)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="yyyy-MM-dd"
          locale={es}
          isClearable
          customInput={<DateCustomInput className="form-control" />}
        />
      </div>
      <div className="col-6 mb-3">
        <label>Hasta</label>
        <DatePicker
          selected={endDate}
          onChange={val => handleFilters('endDate', val, setEndDate)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          dateFormat="yyyy-MM-dd"
          locale={es}
          isClearable
          popperPlacement="top-end"
          customInput={<DateCustomInput className="form-control" />}
        />
      </div>
      <div className="col-12 mb-3">
        <FormSelectMaterial
          id="inspector"
          error={false}
          label="Inspector"
          value={inspector}
          onChange={val => handleFilters('id_inspector', val, setInspector)}
          height={30}
          options={getCatByData('inspector')}
          showAll={true}
          showAllLabel="Todos"
        />
      </div>
      <div className="col-12 mb-3">
        <FormSelectMaterial
          id="ubicacion"
          error={false}
          label="Ubicación"
          value={ubicacion}
          onChange={val => handleFilters('id_localidad', val, setUbicacion)}
          height={30}
          options={getCatByData('localidad')}
          showAll={true}
          showAllLabel="Todas"
        />
      </div>
    </div>
  );
});

export default AvancesFilters;
